export default __webpack_public_path__ + "static/media/property_533.7cc25175.png";